import { Injectable } from "@angular/core";
import { BaseApiService } from "../../shared/utils/base-api.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UserService } from "../../core/user/user.service";
import { map, Observable } from "rxjs";
import { Channel } from "../../core/models/messaging.models";
import { APIResponse } from "../../core/models/api.response.model";

@Injectable({
    providedIn: "root",
})
export class AeolusAPIService extends BaseApiService {
    constructor(private _httpClient: HttpClient, matSnackBar: MatSnackBar, private _userService: UserService) {
        super(matSnackBar);
    }

    BASE_URL = 'https://aeolus-server.curelinktech.in';


    upsertTopicSubscription(topicPath: string, topicMetadata: { [key: string]: any }): Observable<number> {
        return this._httpClient
            .post<Channel>(
                `${this.BASE_URL}/upsert_topic_subscription`,
                {
                    connection_id: this._userService.wsConnectionID,
                    topic_path: topicPath,
                    user_id: this._userService.user.id,
                    topic_metadata: topicMetadata
                }
            )
            .pipe(
                this.delayedRetry(),
                this.errorHandler,
                this.announceFailureResponse,
                map((response: APIResponse<any>) => {
                    return response.data?.ModifiedAt;
                })
            );
    }

    deleteTopicSubscription(topicPath: string): Observable<boolean> {
        return this._httpClient
            .delete<Channel>(
                `${this.BASE_URL}/delete_topic_subscription`,
                {
                    body: {
                        connection_id: this._userService.wsConnectionID,
                        topic_path: topicPath,
                    }
                }
            )
            .pipe(
                this.delayedRetry(),
                this.errorHandler,
                this.announceFailureResponse,
                map((response: APIResponse<any>) => {
                    return response.success
                })
            );
    }
}
